import engineUserAgent from './engine-user-agent.js';

var userAgent = engineUserAgent;
var firefox = userAgent.match(/firefox\/(\d+)/i);
var engineFfVersion = !!firefox && +firefox[1];

export { engineFfVersion as default };
